import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { isMobile, isTablet } from 'react-device-detect'

import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import * as routes from 'core/routing/constants/index'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl' //
import useGetOffer from 'core/hooks/useGetOffer'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import VehicleDetail from 'core/layouts/vehicle-detail'
import {
  Modal,
  ButtonLink,
  ButtonGhost,
  Skeleton,
  ButtonPrimary,
  Row,
  Col
} from 'core/components/ui'
import { getCurrency } from 'core/utils/cultures/unit'
import wizardsShape from 'core/components/wizard/shapes'
import useGetConfig from 'core/hooks/useGetConfig'
import { font, greys, fontFamily } from 'assets/themes/theme-default' //
import { tradeInShape } from '../shapes'
import configurationShape from '../../configuration/shapes'

const Title = styled.h4`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgxxs};
  line-height: ${isMobile && 'normal'};
  margin: ${isMobile ? '0 0 5px 0' : '0 0 20px 0'};
`

const PointOfSalesDatas = styled.div`
  font-size: ${font.size.sm};
  a {
    color: ${props => props.theme.colors.color1.bg};
  }
`
const RowStyled = styled(Row)`
  margin: 20px 0 20px 0;
`

const PointOfSalesDatasEntity = styled.div`
  color: ${greys.dark1};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  margin: 0;
`

export const PricingWrapper = styled.div`
  padding: 1em;
  margin: 20px 0 0 0;
  border-style: solid;
  border-width: 3px;
  border-color: ${props => props.theme.colors.color1.bg}50;
  border-radius: 6px;
`
export const Label = styled.div`
  color: ${greys.dark1};
  font-size: ${font.size.lg};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.medium.name},`}
    ${fontFamily.medium};
`
export const H2 = styled.h2`
  line-height: 37px;
`
export const IconTrade = styled(SVG)`
  opacity: 0.5;
  height: 67px;
  fill: ${props => props.theme.colors.color1.bg};
  vertical-align: middle;
`
export const Name = styled.span`
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
`
export const Footer = styled(Row)`
  z-index: 1;
  padding: 10px 5px;
  background-color: ${props => props.theme.colors.color2.bg};
  width: 100%;
  padding-left: ${isTablet ? '20px' : '5px'};

  & button {
    background-color: ${props => (isMobile ? props.theme.colors.color1.bg : greys.light4)};
    border-color: ${props => props.theme.colors.color1.bg};
    color: ${props => (isMobile ? '#fff' : props.theme.colors.color1.bg)};
    border-radius: 24px !important;
    padding: 0 10px !important;
    text-transform: uppercase;
    font-size: ${font.size.base} !important;
    white-space: initial;
    min-height: 40px;
    height: auto;
    i {
      padding: ${isMobile && '8px'};
      color: ${props => (isMobile ? '#fff' : props.theme.colors.color1.bg)};
      margin-right: ${isMobile ? '0px' : '25px'};
    }
  }
  & h4 {
    color: ${props => (isMobile ? '#fff' : props.theme.colors.color1.bg)};

    font-size: ${font.size.xs};
    & span > span {
      font-weight: ${font.weight.bold};
      font-size: ${font.size.sm};
    }
    & .ati {
      font-size: ${font.size.xxs};
    }
  }
`

const Estimate = props => {
  const [modalVisibleDistributor, setModalVisibleDistributor] = useState(false)
  const [hasNoPrice, setHasNoPrice] = useState(false)
  const { wizards, setWizards, history, tradeIn, setTradeIn, configuration, intl } = props
  const { loading, price, getOffer, errorMessage, errorCode } = useGetOffer({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const { getConfig } = useGetConfig({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const { vehicle, user, pointOfSales, tradeInprice, futherInformations, comment } = tradeIn
  const { prices } = vehicle
  const { civility, firstName, lastName } = user
  const { previousWizard } = wizards
  const { opportunitySettings, urlReturn, labelUrlReturn } = configuration

  const { totalOptionsPrice, totalServiceContractsPrice, totalPaintPrice, totalSaddleries } = prices

  const newPrice = (tradeInprice && tradeInprice.amount) || 0
  const totalPrice =
    newPrice + totalOptionsPrice + totalServiceContractsPrice + totalPaintPrice + totalSaddleries
  const activateNextStep = gotoFinalsation => {
    let redirectId

    switch (previousWizard) {
      case 'configurator':
        redirectId = 1
        break
      case 'stock':
        redirectId = 2
        break
      default:
        break
    }

    let routeToRedirect

    switch (redirectId) {
      case 1:
      default:
        routeToRedirect = gotoFinalsation
          ? routes.REDIRECT_TO_ROUTE_CONFIGURATOR_FINALIZATION
          : routes.REDIRECT_TO_ROUTE_CONFIGURATOR_FUNDING
        break
      case 2:
        routeToRedirect = gotoFinalsation
          ? routes.REDIRECT_TO_ROUTE_STOCK_FINALIZATION
          : routes.REDIRECT_TO_ROUTE_STOCK_FUNDING
        break
    }

    history.push(routeToRedirect)
  }
  const renderAddress = () => {
    const address = []

    if (pointOfSales.address1) {
      address.push(pointOfSales.address1)
    }
    if (pointOfSales.address2) {
      if (address.length > 0) address.push(<br key="1" />)

      address.push(pointOfSales.address2)
    }
    if (pointOfSales.complementaryAddress1) {
      if (address.length > 0) address.push(<br key="2" />)

      address.push(pointOfSales.complementaryAddress1)
    }
    if (pointOfSales.complementaryAddress2) {
      if (address.length > 0) address.push(<br key="3" />)

      address.push(pointOfSales.complementaryAddress2)
    }
    address.push(<br key="4" />)
    if (pointOfSales.zipCode) {
      address.push(pointOfSales.zipCode)
    }
    if (pointOfSales.city) {
      if (address.length > 0) address.push(' ')

      address.push(pointOfSales.city)
    }

    return address
  }

  //const { DPOName1, DPOName2, DPOEmail, entityName } = pointOfSales

  const mailto = pointOfSales ? `mailto:${pointOfSales.email}` : null
  const tel = pointOfSales ? `tel:${pointOfSales.phonePrefixCode}${pointOfSales.phone}` : null

  const handleHome = () => {
    //setLayoutVehiclePreview(null)
    //setLayoutTradeInPreview(null)
    const queryParams = new URLSearchParams()
    if (configuration.urlReturn) queryParams.set('urlReturn', configuration.urlReturn)
    if (configuration.labelUrlReturn)
      queryParams.set('labelUrlReturn', configuration.labelUrlReturn)
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

    history.push(`/${configuration.campaign.uid}${queryString}`)
  }

  const renderPointOfSales = (
    <>
      {pointOfSales && (
        <>
          {!isMobile && (
            <Title>
              <FormattedMessage id="tradeIn-estimate-pointOfSales-title" />
            </Title>
          )}
          <PointOfSalesDatasEntity>{pointOfSales.name}</PointOfSalesDatasEntity>
          <PointOfSalesDatas>{renderAddress()}</PointOfSalesDatas>
          <PointOfSalesDatas>
            <ButtonLink style={{ height: 'auto' }} type="link" href={mailto}>
              {pointOfSales.email}
            </ButtonLink>{' '}
            {pointOfSales.phonePrefixCode && pointOfSales.phone && (
              <ButtonLink style={{ height: 'auto' }} type="link" href={tel}>
                {`${pointOfSales.phonePrefixCode} ${pointOfSales.phone}`}
              </ButtonLink>
            )}
          </PointOfSalesDatas>
        </>
      )}
    </>
  )

  const redirectUrl = () => {
    window.location.replace(urlReturn)
  }

  useEffect(() => {
    const runIt = p => {
      const { amount } = p
      const { offerValidityMaximumDays } = opportunitySettings
      const extendedTradeInprice = {
        ...tradeInprice,
        amount,
        offerValidityDate: moment().add(offerValidityMaximumDays, 'days')
      }

      if (amount === null) {
        setHasNoPrice(true)
      } else {
        setHasNoPrice(false)
      }

      setTradeIn({
        ...tradeIn,
        tradeInprice: extendedTradeInprice
      })

      setWizards({ ...wizards, showWizardNavigation: false })
    }

    if (price) runIt(price)
  }, [price])

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_ESTIMATE)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    const bearer = JSON.parse(localStorage.getItem('bearer'))
    const { campaign, currentPricingPolicy } = configuration
    const { pricingPolicy } = vehicle
    let defectsMustGoToManual = false
    if (campaign.tradeInConfig === 2) {
      defectsMustGoToManual =
        bearer.entityGroupId !== bearer.originEntityGroupId ||
        (pricingPolicy && currentPricingPolicy && pricingPolicy.id !== currentPricingPolicy.id)
    }

    const { stockEntranceMaximumDays } = opportunitySettings

    const extendedVehicle = {
      ...vehicle,
      stockEntranceMaximumDays,
      defectsMustGoToManual
    }

    const { uid } = campaign
    const runIt = async () => {
      if (pointOfSales.id !== JSON.parse(localStorage.getItem('bearer')).pointOfSaleId) {
        await getConfig({ token: uid, pointOfSaleId: pointOfSales.id })
      }

      if (!tradeInprice) getOffer({ user, vehicle: extendedVehicle, futherInformations, comment })
    }

    runIt()
  }, [])

  const renderBtnFooter = () => (
    <Footer style={{ position: 'fixed', bottom: '0', left: '0' }}>
      <Col span={12}>
        <h4>
          <FormattedMessage id="tradeIn-estimate-view-title" />
        </h4>
        <h4>
          {totalPrice !== 0 && !Number.isNaN(Number(totalPrice)) ? (
            <>
              <span>
                <FormattedNumber value={totalPrice} /> {getCurrency()}{' '}
              </span>
              <FormattedMessage id="ati" class="ati" />
            </>
          ) : (
            ' - '
          )}
        </h4>
      </Col>
      <Col span={12} align="middle">
        {!errorMessage && (
          <>
            {urlReturn && labelUrlReturn ? (
              <ButtonPrimary onClick={redirectUrl} disabled={loading} size={17} ellipsis>
                {labelUrlReturn}
              </ButtonPrimary>
            ) : (
              <ButtonPrimary size={17} onClick={handleHome}>
                <FormattedMessage id="prewiew-vehicle-button-1" />
              </ButtonPrimary>
            )}
          </>
        )}
      </Col>
    </Footer>
  )

  const renderCivility = () => {
    let civilityLabel = ''
    if (civility) {
      civilityLabel =
        civility === 2
          ? intl.formatMessage({ id: 'tradeIn-contact-civility-reply-1' })
          : intl.formatMessage({ id: 'tradeIn-contact-civility-reply-2' })

      civilityLabel += ' '
    }

    return (
      <FormattedMessage
        id="tradeIn-estimate-vehicle-no-price-title-1"
        values={{
          user: (
            <>
              {`${civilityLabel}`}
              <Name>{`${firstName} ${lastName}`}</Name>
            </>
          )
        }}
      />
    )
  }
  return (
    <MainContentWrapper
      cssId="globaldealer-title-10"
      title={intl.formatMessage({
        id: 'tradeIn-estimate-view-title'
      })}
    >
      {!isMobile && (
        <Row type="flex" justify="start" gutter={24}>
          {!errorMessage && (
            <Col>
              <ButtonPrimary
                className="globaldealer-btn-preview"
                icon="plus-circle"
                size={19}
                onClick={handleHome}
                disabled={loading}
              >
                <FormattedMessage id="prewiew-vehicle-button-1" />
              </ButtonPrimary>
            </Col>
          )}

          {urlReturn && labelUrlReturn && (
            <Col>
              <ButtonGhost
                className="globaldealer-btn-preview"
                onClick={redirectUrl}
                disabled={loading}
                size={19}
              >
                {labelUrlReturn}
              </ButtonGhost>
            </Col>
          )}
        </Row>
      )}
      <RowStyled type="flex" justify="start" gutter={24}>
        <Col lg={isMobile ? 24 : 16} xs={24}>
          {/* On mobile add the "new estimate" button on top if there is a custom button set */}
          {!errorMessage && (
            <>
              {isMobile && urlReturn && labelUrlReturn && (
                <ButtonPrimary
                  className="globaldealer-btn-preview"
                  icon="plus-circle"
                  size={17}
                  onClick={handleHome}
                  style={{ marginBottom: '20px' }}
                >
                  <FormattedMessage id="prewiew-vehicle-button-1" />
                </ButtonPrimary>
              )}
            </>
          )}

          <Skeleton loading={loading} active>
            {tradeInprice && tradeInprice.amount !== null && (
              <>
                <Row type="flex" gutter={20} justify="center">
                  <Col span={24}>
                    {renderCivility()}
                    <br />
                    <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-1" />
                    <br />
                    <FormattedMessage id="tradeIn-estimate-vehicle-price-subtitle-1" />
                    <br />
                    <br />
                    <FormattedMessage id="tradeIn-estimate-vehicle-price-subtitle-2" />
                    <br />
                    <br />
                    <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-4" />
                    <Row type="flex">
                      <Col xs={{ span: 22 }} lg={{ span: 11 }}>
                        <PricingWrapper>
                          <Row type="flex" justify="space-between">
                            <Col span={16}>
                              <Label>
                                <FormattedMessage id="tradeIn-estimate-view-title" />
                                <H2>
                                  <FormattedNumber value={totalPrice} />
                                  {getCurrency()}
                                </H2>
                                <Label>
                                  <FormattedMessage id="ati" />
                                </Label>
                              </Label>
                            </Col>
                            <IconTrade svg={svg.tradeInOffer} />
                          </Row>
                        </PricingWrapper>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}
            {hasNoPrice && (
              <Row type="flex" gutter={20} justify="center">
                <Col span={24}>
                  {renderCivility()}
                  <br />
                  <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-1" />
                  <br />
                  <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-2" />
                  <br />
                  <br />
                  <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-3" />
                  <br />
                  <br />
                  <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-4" />
                  <Row type="flex">
                    <Col xs={{ span: 24 }} lg={{ span: 11 }}>
                      <PricingWrapper>
                        <Row type="flex" justify="space-between">
                          <Col span={16}>
                            <Label>
                              <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-5" />
                              <h2>-</h2>
                            </Label>
                          </Col>
                          <IconTrade svg={svg.pending} />
                        </Row>
                      </PricingWrapper>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {errorMessage && errorCode === 429 && (
              <>
                {renderCivility()}
                <br />
                <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-6" />
                <br />
                <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-1" />
                <br />
                <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-7" />
              </>
            )}
            {errorMessage && errorCode !== 429 && (
              <>
                {renderCivility()}
                <br />
                <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-8" />
                <br />
                <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-1" />
                <br />
                <FormattedMessage id="tradeIn-estimate-vehicle-no-price-subtitle-7" />
              </>
            )}
          </Skeleton>
        </Col>
        {!isMobile && (
          <Col lg={isMobile ? 24 : 8} xs={24}>
            {renderPointOfSales}
          </Col>
        )}
      </RowStyled>
      <VehicleDetail
        vehicle={vehicle}
        showDetails={false}
        showDetailPrice={false}
        price={tradeInprice && tradeInprice.amount}
        tradeInprice={tradeInprice}
        previousWizard={previousWizard}
        activateNextStep={activateNextStep}
      />
      {isMobile && (
        <>
          <Title>
            <FormattedMessage id="tradeIn-estimate-pointOfSales-title" />
          </Title>
          <Col lg={isMobile ? 24 : 8} xs={24}>
            {renderPointOfSales}
          </Col>
          {/* <Row type="flex" justify="center" gutter={[12, 12]}>
            <Col>
              <ButtonGhost onClick={() => setModalVisibleDistributor(true)}>
                <FormattedMessage id="prewiew-vehicle-button-2" />
              </ButtonGhost>
            </Col>
          </Row> */}
          <Modal
            title={intl.formatMessage({ id: 'tradeIn-estimate-pointOfSales-title' })}
            visible={modalVisibleDistributor}
            footer={null}
            onCancel={() => setModalVisibleDistributor(false)}
          >
            <Row type="flex" justify="center">
              <Col>{renderPointOfSales}</Col>
            </Row>
          </Modal>
        </>
      )}
      {isMobile && renderBtnFooter()}
    </MainContentWrapper>
  )
}

Estimate.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  configuration: configurationShape.isRequired
}

export default withRouter(injectIntl(Estimate))
